module.exports = __webpack_public_path__ + "media/slide-1.573bfee3.mp4";